import { render, staticRenderFns } from "./comp_ProductCardImage.vue?vue&type=template&id=1544d146&scoped=true&"
import script from "./comp_ProductCardImage.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCardImage.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCardImage.vue?vue&type=style&index=0&id=1544d146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544d146",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VHover,VProgressCircular})
